import { CheckCircle2, XCircle, Clock, Radio, Sparkles } from "lucide-react";
import { fmtDate, tname } from "@/lib/api";
import { ProbBar } from "@/components/MatchCard";

function Status({ item }) {
  const m = item.match;
  if (m.status === "FINISHED") {
    if (item.hit === true) return <span className="flex items-center gap-1 text-[var(--win)]"><CheckCircle2 size={14} /> GIOCATA · AZZECCATO</span>;
    if (item.hit === false) return <span className="flex items-center gap-1 text-[var(--loss)]"><XCircle size={14} /> GIOCATA · NON AZZECCATO</span>;
    return <span className="flex items-center gap-1 text-[var(--win)]"><CheckCircle2 size={14} /> GIOCATA</span>;
  }
  if (m.status === "IN_PLAY" || m.status === "PAUSED") return <span className="flex items-center gap-1 text-[var(--loss)] animate-pulse"><Radio size={14} /> LIVE</span>;
  return <span className="flex items-center gap-1 text-[var(--gold)]"><Clock size={14} /> {fmtDate(m.utcDate)}</span>;
}

const Team = ({ t, right }) => (
  <div className={`flex items-center gap-2 min-w-0 ${right ? "flex-row-reverse text-right" : ""}`}>
    <img src={t.crest} alt="" className="w-8 h-8 object-contain shrink-0" />
    <span className="font-semibold truncate">{tname(t)}</span>
  </div>
);

export default function PredictionTile({ item, index, onOpen }) {
  const m = item.match;
  const p = item.prediction?.data;
  const played = m.status === "FINISHED";
  const ft = m.score.fullTime;
  const border = item.hit === true ? "border-l-4 !border-l-[var(--win)]" : item.hit === false ? "border-l-4 !border-l-[var(--loss)]" : "";

  return (
    <button
      data-testid={`public-prediction-${item.match_id}`}
      onClick={p ? onOpen : undefined}
      className={`panel p-5 text-left w-full fade-up ${p ? "panel-hover cursor-pointer" : "cursor-default"} ${border}`}
      style={{ animationDelay: `${Math.min(index, 12) * 35}ms` }}
    >
      <div className="flex justify-between gap-3 text-[11px] font-mono text-slate-400 uppercase">
        <span className="truncate">{item.competition_name} · {item.round_label}</span>
        <span className="shrink-0 font-semibold"><Status item={item} /></span>
      </div>
      <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3 mt-4">
        <Team t={m.homeTeam} />
        <div className="text-center min-w-[56px]">
          {played || ft.home !== null ? (
            <div className="font-display text-3xl font-extrabold leading-none">{ft.home}-{ft.away}</div>
          ) : p ? (
            <div className="font-display text-3xl font-extrabold text-[var(--gold)] leading-none">{p.esito}</div>
          ) : (
            <div className="font-display text-2xl font-bold text-slate-600">VS</div>
          )}
          {played && p && <div className="font-mono text-[11px] text-[var(--gold)] mt-1">pron. {p.esito}</div>}
        </div>
        <Team t={m.awayTeam} right />
      </div>
      {p ? (
        <>
          <div className="mt-4"><ProbBar p={p} /></div>
          <div className="flex justify-between text-xs font-mono text-slate-400 mt-2">
            <span>{p.goal_nogoal} · {p.over_under}</span>
            <span>Confidenza <b className="text-white">{p.confidenza}%</b></span>
          </div>
        </>
      ) : (
        <div className="mt-4 text-xs text-slate-500 flex items-center gap-1">
          {played ? "Nessun pronostico per questa partita" : <><Sparkles size={12} /> Pronostico AI in arrivo</>}
        </div>
      )}
    </button>
  );
}
